import { Box, Divider, List, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { SecondeSegmentListItem } from './SecondeSegmentListItem';
import { ThirdSegment } from '../ThirdSegment';

export const SecondeSegment = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={
        isDesktop
          ? {
              borderRadius: '16px',
            }
          : {
              borderRadius: '16px',
              border: '1px solid',
              borderColor: 'primary.shade_100',
            }
      }
    >
      <Box
        sx={{
          borderRadius: '16px 16px 0px 0px',
          backgroundColor: 'white',
          p: isDesktop ? '18px 24px' : '20px 16px 22px',
          zIndex: 1,
        }}
      >
        <Typography component='h1' variant={isDesktop ? 'h5' : 'h3'}>
          {dictionary.howDoYouRequestEligibilityForConsumableEquipment}
        </Typography>
        <Divider
          aria-hidden='true'
          sx={{ borderColor: 'primary.shade_100', mt: 2 }}
        />
      </Box>
      <List
        sx={{
          borderRadius: '0px 0px 16px 16px',
          backgroundColor: 'white',
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          margin: 0,
          padding: isDesktop ? '10px 24px 34px 24px' : '0 16px 34px',
          zIndex: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '25px',
        }}
      >
        <SecondeSegmentListItem
          title={dictionary.step1ObtainingAMedicalRecommendation}
          subtitle={
            dictionary.youMustContactYourDoctorToGetAMedicalRecommendationForEquipment
          }
        />
        <SecondeSegmentListItem
          title={dictionary.step2SubmittingAnApplication}
          subtitle={
            dictionary.youMustSubmitAnApplicationAndAttachTheMedicalRecommendationYouReceived
          }
        />
        <ThirdSegment />
      </List>
    </Stack>
  );
};
